module.exports = __webpack_public_path__ + "static/img/5.6e84695.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/5.jpeg
// module id = ITwy
// module chunks = 3